import { c as _c } from "react/compiler-runtime";
import type * as React from 'react';
import { flow } from 'effect';
import type { FileType } from '@/atoms/file-types';
import { Textarea } from '@/components/ui/textarea';
import { DataTransferItemListReader, readEntryFiles } from '@/lib/filesHandler';
import { cn } from '@/lib/utils';
export function TextareaInput(t0) {
  const $ = _c(16);
  let className;
  let fileTypes;
  let handleChange;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      fileTypes,
      onFileChange: handleChange,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = fileTypes;
    $[3] = handleChange;
    $[4] = props;
  } else {
    className = $[1];
    fileTypes = $[2];
    handleChange = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== fileTypes) {
    t1 = new DataTransferItemListReader(fileTypes.filter(_temp).map(_temp2));
    $[5] = fileTypes;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const dataTransferItemListReader = t1;
  let t2;
  if ($[7] !== dataTransferItemListReader || $[8] !== handleChange) {
    t2 = function dropHandler(event) {
      event.preventDefault();
      Promise.all(dataTransferItemListReader.readDataTransferItemList(event.dataTransfer.items)).then(flow(_temp3, _temp4, handleChange)).catch(console.error);
    };
    $[7] = dataTransferItemListReader;
    $[8] = handleChange;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const dropHandler = t2;
  let t3;
  if ($[10] !== className) {
    t3 = cn("size-full max-h-full resize-none rounded-none bg-background px-[30px] py-3 align-top outline-hidden focus-visible:ring-0 dark:bg-transparent dark:text-neutral-400 dark:placeholder:text-neutral-600", "border-0", className);
    $[10] = className;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== dropHandler || $[13] !== props || $[14] !== t3) {
    t4 = <Textarea aria-label="Text input" className={t3} onDrop={dropHandler} {...props} />;
    $[12] = dropHandler;
    $[13] = props;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}
function _temp4(t0) {
  const {
    title,
    content
  } = t0;
  return {
    value: content,
    name: title
  };
}
function _temp3(x) {
  return readEntryFiles(x);
}
function _temp2(fileType_0) {
  return fileType_0.type;
}
function _temp(fileType) {
  return fileType.checked;
}